import request from "@/util/request";

export function Teacher_GetLabels(params) {
  return request({
    url: "/pc/Teacher/Teacher_GetLabels",
    method: "get",
    params,
  });
}
export function Teacher_GetList(params) {
  return request({
    url: "/pc/Teacher/Teacher_GetList",
    method: "get",
    params,
  });
}
export function Teacher_GetDetail(params) {
  return request({
    url: "/pc/Teacher/Teacher_GetDetail",
    method: "get",
    params,
  });
}
export function Teacher_GetMaterials(params) {
  return request({
    url: "/pc/Teacher/Teacher_GetMaterials",
    method: "get",
    params,
  });
}

export function Teacher_GetCourses(params) {
  return request({
    url: "/pc/Teacher/Teacher_GetCourses",
    method: "get",
    params,
  });
}

export function Teacher_GetOthers(params) {
  return request({
    url: "/pc/Teacher/Teacher_GetOthers",
    method: "get",
    params,
  });
}
export function Teacher_Prebook(data) {
  return request({
    url: "/pc/Teacher/Teacher_Prebook",
    method: "post",
    data,
  });
}
